import React, { useEffect, useState } from 'react'
import { useDataProvider } from 'react-admin';
import { auth } from "../../src/firebase";
import { onAuthStateChanged } from 'firebase/auth';
import ProfileEdit from '../components/ProfileEdit';
import _extendLayout from "../layout/_extendLayout";
import { useNavigate } from 'react-router-dom';

const ProfilePage = () => {
    const [userId, setUserId] = useState(null);
    const [role, setRole] = useState(null);
    const [userDetails, setUserDetails] = useState(null);
    const [clientData, setClientData] = useState(null);
    const dataProvider = useDataProvider();
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuth = onAuthStateChanged(auth, async (user) => {
            if(user) {
                setUserId(user.uid);

                try {
                    const idTokenResult = await user.getIdTokenResult();
                    if (idTokenResult.claims.role) {
                        setRole(idTokenResult.claims.role);  // Set role from custom claims
                    } else {
                        setRole(null);
                    }
                    await fetchUserProfile(user.uid); // Fetch user profile after token validation
                } catch (error) {
                    console.error("Error fetching custom claims:", error.message);
                    setRole(null);
                }
            } else {
                setUserId(null);
                setRole(null);
                navigate("/");
            }
        });

        return () => checkAuth();
    }, [auth])

    const fetchUserProfile = async (userId) => {
        try {
            const res = await dataProvider.getOne("users", { id: userId });
            
            setUserDetails(res.data);
            if(res.data?.client?.id) {
                fetchClientData(res.data?.client?.id);
            }
        } catch (err) {
            console.log(err)
        }
    }

    const fetchClientData = async (clientId) => {
        try {
            const res = await dataProvider.getOne("clients", { id: clientId });
            setClientData(res.data);
        } catch(err) {
            console.log(err);
        }
    }
    
    return (
        <>
            {role === "admin" || (clientData && userDetails) ? (
                <_extendLayout>
                    <ProfileEdit userId={userId} role={role} userDetails={userDetails} clientData={clientData} />
                </_extendLayout>
            ) : (
                <_extendLayout>
                    <p>Loading...</p>
                </_extendLayout>
            )}
        </>
    )
};

export default ProfilePage;
